import { render, staticRenderFns } from "./SliceCallOutRow.vue?vue&type=template&id=3c36dcc1&lang=pug&"
import script from "./SliceCallOutRow.vue?vue&type=script&lang=js&"
export * from "./SliceCallOutRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports